import { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const actionBtnSx = {
  textTransform: 'none',
  fontFamily: 'Rubik',
  fontWeight: 600,
  fontSize: { xs: '11px', sm: '12px', xl: '15px' },
  height: { xs: '30px', sm: '32px', xl: '40px' },
  minWidth: { xs: '76px', sm: '90px', xl: '120px' },
  borderRadius: '5px',
  boxShadow: 'none',
};

// Collects the rejection_note the reject API requires, then hands it back to the caller.
const RejectQuickTurnPopup = ({ open, request, isSubmitting, onClose, onSubmit }) => {
  const [note, setNote] = useState('');
  const [error, setError] = useState('');

  const handleClose = () => {
    setNote('');
    setError('');
    onClose && onClose();
  };

  const handleSubmit = () => {
    if (!note.trim()) {
      setError('Rejection note is required');
      return;
    }
    onSubmit && onSubmit(note.trim());
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '5px' } }}>
      <DialogContent sx={{ p: 3 }}>
        <Typography sx={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: '16px', color: '#08231B', mb: 1 }}>
          Reject Quick Turn Request
        </Typography>
        {request?.event_name && (
          <Typography sx={{ fontFamily: 'Rubik', fontSize: '13px', color: '#555', mb: 2 }}>
            {request.event_name}
          </Typography>
        )}
        <TextField
          autoFocus
          multiline
          minRows={3}
          fullWidth
          placeholder="Explain why this quick turn is being rejected"
          value={note}
          onChange={(e) => {
            setNote(e.target.value);
            if (error) setError('');
          }}
          error={!!error}
          helperText={error}
          inputProps={{ maxLength: 500 }}
          sx={{ '& .MuiOutlinedInput-root': { fontFamily: 'Rubik', fontSize: '13px' } }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          disabled={isSubmitting}
          sx={{ ...actionBtnSx, borderColor: '#08231B', color: '#08231B', '&:hover': { borderColor: '#08231B', backgroundColor: '#08231B14' } }}
        >
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmitting}
          variant="contained"
          onClick={handleSubmit}
          sx={{
            ...actionBtnSx,
            backgroundColor: '#08231B',
            color: '#00d744',
            '&:hover': { backgroundColor: '#08231Bcc' },
            '&.MuiLoadingButton-loading': { color: 'transparent' },
          }}
        >
          Reject
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RejectQuickTurnPopup;
